<div class="container-box">
  <div #sessionContainer>
    <div id="timeoutContainer" class="model-cover terms" *ngIf="isIdleFlag">
       <div class="model-box" (keydown)="hdrHandleKeydownTimer($event)">
          <div class="modal-header">
            <h2 id="timeoutContainerTitle" tabindex="-1">Your session will end in 5 minutes</h2>
          </div>
          <div class="modal-body">To keep your session active and avoid losing any work you've done, click Continue.</div>
          
          <div class="text-right modal-footer">
            <div class="btn-group">
              <a role="button" href="javascript:void(0)" class="btn btn-secondary pull-right" (click)="resetSessionTimerPopup()">Continue</a>
              <a href="javascript:void(0)" class="btn btn-link" (click)="logoutCurrentUserPopup();">Cancel</a>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>

      <div id="logoutContainer" class="model-cover terms" *ngIf="logoutAlertFlag">
        <div class="model-box" (keydown)="hdrHandleKeydownTimer($event)">
          <div class="modal-header">
            <h2 id="logoutContainerTitle" tabindex="-1">Session ended</h2>
          </div>
          <div class="modal-body">For security reasons, your session has ended due to inactivity. Your work will be lost. Please log in again.</div>
          <div class="text-right modal-footer">
            <div class="btn-group">
              <a role="button" class="btn btn-secondary" href="javascript:void(0)" (click)="logoutAlertClosePopup()">Close</a>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
